import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined";
import PagesContainer from "modules/brands";
import ContentScheduleContainer from "modules/contentSchedule";
import GamesContainer from "modules/games";
import ManageArticles from "modules/manageArticles";
import Modules from "modules/moduleTemplates";
import Studios from "modules/studios";
import TagsAndMetadata from "modules/tagsAndMetadataTags/pages/TagsAndMetadataTags";
import DynamicTranslationsPage from "modules/translations/pages/DynamicTranslations";
import StaticTranslationsPage from "modules/translations/pages/StaticTranslations";
import Users from "modules/users/pages/Users";
import { ClockIcon } from "shared/theme/icons/ClockIcon";
import { CorporateIcon } from "shared/theme/icons/CorporateIcon";
import { FileIcon } from "shared/theme/icons/FileIcon";
import { GameIcon } from "shared/theme/icons/GameIcon";
import { TagIcon } from "shared/theme/icons/TagIcon";
import { TelegramIcon } from "shared/theme/icons/Telegram";
import { TranslationsIcon } from "shared/theme/icons/TranslationsIcon";
import Broadcasts from "../../modules/broadcasts/pages/Broadcasts";
import BulletinBoard from "../../modules/bulletinBoard";
import CustomerTickets from "../../modules/customerTickets/pages/CustomerTickets";
import FaqGroupContainer from "../../modules/faqGroups";
import Faqs from "../../modules/faqGroups/pages/Faqs";
import RolesAndPermissions from "../../modules/rolesAndPermissions";
import { AccountTreeIcon } from "../theme/icons/AccountTree";
import { CSCentreIcon } from "../theme/icons/CSCentreIcon";
import { QuizIcon } from "../theme/icons/Quiz";
import { WidgetsIcon } from "../theme/icons/WidgetsIcon";
import {
  GAMES_PATH,
  TAGS_AND_METADATA_PATH,
  MODULES_PATH,
  STUDIOS_PATH,
  BRAND_TAB_PATH,
  FAQ_GROUP_PATH,
  FAQS_PATH,
  TRANSLATIONS_DYNAMIC_PATH,
  TRANSLATIONS_STATIC_PATH,
  BULLETINS_PATH,
  ROLES_AND_PERMISSIONS,
  CUSTOMER_SERVICES_CENTRE,
  USERS_PATH,
  BROADCASTS_PATH,
  MANAGE_ARTICLES_PATH,
  TRANSLATIONS_PATH,
  HELP_CENTER_PATH,
  TELEGRAM_PATH,
  CONTENT_SCHEDULE_PATH,
} from "./paths";
import { Routing } from "./types";

export const privateRoutes: Routing = {
  pages: {
    pathname: BRAND_TAB_PATH,
    title: "Brands & Pages",
    Component: PagesContainer,
    Icon: WorkspacesOutlinedIcon,
    algoliaIndexName: process.env.REACT_APP_ALGOLIA_GAMES_INDEX_NAME || "",
    elements: [],
    category: "general",
  },
  telegram: {
    pathname: TELEGRAM_PATH,
    title: "Telegram",
    Icon: TelegramIcon,
    category: "general",
    algoliaIndexName: process.env.REACT_APP_ALGOLIA_USERS_INDEX_NAME || "",
    elements: [
      {
        pathname: USERS_PATH,
        Component: Users,
        title: "Users",
      },
      {
        pathname: BROADCASTS_PATH,
        Component: Broadcasts,
        title: "Broadcasts",
      },
    ],
  },
  studios: {
    pathname: STUDIOS_PATH,
    Component: Studios,
    title: "Studios",
    Icon: CorporateIcon,
    category: "general",
  },
  games: {
    pathname: GAMES_PATH,
    title: "Games",
    Component: GamesContainer,
    Icon: GameIcon,
    algoliaIndexName: process.env.REACT_APP_ALGOLIA_GAMES_INDEX_NAME || "",
    category: "general",
  },
  modules: {
    pathname: MODULES_PATH,
    Component: Modules,
    title: "Modules",
    Icon: WidgetsIcon,
    algoliaIndexName: process.env.REACT_APP_ALGOLIA_GAMES_INDEX_NAME || "",
    category: "general",
  },
  gamesTags: {
    pathname: TAGS_AND_METADATA_PATH,
    Component: TagsAndMetadata,
    title: "Tags and Metadata",
    algoliaIndexName: process.env.REACT_APP_ALGOLIA_TAGS_INDEX_NAME || "",
    Icon: TagIcon,
    category: "general",
  },
  contentSchedule: {
    pathname: CONTENT_SCHEDULE_PATH,
    Component: ContentScheduleContainer,
    title: "Content Schedule",
    Icon: ClockIcon,
    algoliaIndexName: process.env.REACT_APP_ALGOLIA_GAMES_INDEX_NAME || "",
    category: "support",
  },
  translations: {
    pathname: TRANSLATIONS_PATH,
    title: "Translations",
    Icon: TranslationsIcon,
    algoliaIndexName:
      process.env.REACT_APP_ALGOLIA_DYNAMIC_TRANSLATIONS_INDEX_NAME || "",
    category: "support",
    elements: [
      {
        pathname: TRANSLATIONS_STATIC_PATH,
        title: "Static Translations",
        Component: StaticTranslationsPage,
      },
      {
        pathname: TRANSLATIONS_DYNAMIC_PATH,
        title: "Dynamic Translations",
        Component: DynamicTranslationsPage,
      },
    ],
  },
  manageArticles: {
    pathname: MANAGE_ARTICLES_PATH,
    Component: ManageArticles,
    title: "Manage Articles",
    Icon: FileIcon,
    elements: [],
    category: "support",
  },
  helpCenter: {
    pathname: HELP_CENTER_PATH,
    title: "Help Center",
    Icon: QuizIcon,
    elements: [
      {
        pathname: FAQ_GROUP_PATH,
        title: "FAQ",
        Component: FaqGroupContainer,
        nestedRoute: {
          title: "FAQ",
          pathname: FAQS_PATH,
          Component: Faqs,
        },
      },
      {
        pathname: BULLETINS_PATH,
        title: "Bulletin Board",
        Component: BulletinBoard,
      },
    ],
    category: "support",
  },
  customerServicesCentre: {
    pathname: CUSTOMER_SERVICES_CENTRE,
    Component: CustomerTickets,
    title: "CS Centre",
    algoliaIndexName:
      process.env.REACT_APP_ALGOLIA_CUSTOMER_SUPPORT_TICKETS_INDEX_NAME || "",
    Icon: CSCentreIcon,
    category: "support",
  },
  rolesAndPermissions: {
    pathname: ROLES_AND_PERMISSIONS,
    title: "Roles & Permissions",
    Component: RolesAndPermissions,
    Icon: AccountTreeIcon,
    category: "admin",
  },
};
